import { useEffect, useState } from "react";
import getNowPlayingItem from "../APIs/SpotifyAPI";
import ProgressBar from "@ramonak/react-progress-bar";

export function SpotifyPlayer(props) {
  const [result, setResult] = useState({});

  useEffect(() => {
    Promise.all([
      getNowPlayingItem(
        props.client_id,
        props.client_secret,
        props.refresh_token
      ),
    ]).then((results) => {
      setResult(results[0]);
    });
  });

  return result.isPlaying ? (
    <div
      className="spotify-cont"
      style={{
        backgroundImage: `url(${result.albumImageUrl})`,
        backgroundSize: "cover",
      }}
    >
      <div className="blur"></div>
      <div className="spotify-track">
        <a href={result.songUrl} target="_blank" rel="noreferrer">
          <div className="song-img">
            <img
              src={result.albumImageUrl}
              alt={`Album cover for ${result.title}`}
            />
          </div>
          <div className="song-info">
            <div className="song-title">{result.title}</div>
            <div className="song-artist">by {result.artist}</div>
            <ProgressBar
              completed={result.progressMs}
              maxCompleted={result.durationMs}
              bgColor="#dbb3fe"
              height="8px"
              labelColor="#dbb3fe"
              baseBgColor="#121212"
              transitionDuration="0s"
            />
          </div>
        </a>
      </div>
    </div>
  ) : (
    <div
      className="spotify-cont"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/bg.webp)`,
        backgroundSize: "cover",
      }}
    >
      <div className="blur"></div>
      <div className="spotify-track">
        <div className="song-img">
          <img
            src="assets/images/spotify.webp"
            alt="Spotify logo"
          />
        </div>
        <div className="song-info">
          <div className="song-title">Not listening to Spotify rn!</div>
        </div>
      </div>
    </div>
  );
}
